import { render, staticRenderFns } from "./Penalties.vue?vue&type=template&id=17e6438e"
import script from "./Penalties.vue?vue&type=script&lang=js"
export * from "./Penalties.vue?vue&type=script&lang=js"
import style0 from "./Penalties.vue?vue&type=style&index=0&id=17e6438e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports